<template>
  <div v-if="contents" class="mark-down-sb" v-html="sanitizedMarkdown"></div>
</template>

<script>
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify';

export default {
  name: 'MdSb',
  props: {
    contents: { type: String, default: '' }
  },
  data() {
    return {
      md: new MarkdownIt({
        html: true,
        breaks: true,
        linkify: true
      })
    };
  },
  computed: {
    sanitizedMarkdown() {
      if (!this.contents) return '';

      // 1) 주석 제거
      const withoutComments = this.contents.replace(/<!--[\s\S]*?-->/g, '');

      // 2) markdown / html 처리
      const rawHtml = /<\/?[a-z][\s\S]*>/i.test(withoutComments.trim());
      const rendered = rawHtml ? withoutComments : this.md.render(withoutComments);

      // 3) sanitize
      const clean = DOMPurify.sanitize(rendered, {
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
        ALLOW_COMMENTS: false
      });

      // 4) div로 감싸기
      return `<div class="md-wrapper">${clean}</div>`;
    }
  }
};
</script>

<style scoped>
.md-wrapper {
  width: 100%;
  overflow-x: auto;
}
</style>
